// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarCentroAsistencias_main__K7eZW","intro":"ModalEditarCentroAsistencias_intro__jpb0O","input":"ModalEditarCentroAsistencias_input__u43+s"};